<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="rptTypes" v-model="form.rptType" :label="label.rptType" item-text="label" item-value="value"
                          data-vv-name="rptType" :data-vv-as="label.rptType" :error-messages="errors.collect('rptType')" @change="doRptType($event)"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6></v-flex>

                      <v-flex lg6 sm6 xs12>
                        <cal-picker v-model="form.createdDate" :label="label.createdDate" :data-vv-as="label.createdDate" data-vv-name="createdDate" :error-messages="errors.collect('createdDate')" :min="fromDateMinDate" :max="today"
                        :disabled="disableCreatedDate"></cal-picker>
                      </v-flex>
                      <v-flex lg6 sm6></v-flex>

                      <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="acctPeriodList" v-model="form.acctPeriod" :label="label.acctPeriod" item-text="label" item-value="value"
                          data-vv-name="acctPeriod" :data-vv-as="label.acctPeriod" :error-messages="errors.collect('acctPeriod')" v-validate="'required'"
                          :disabled="disableAcctPeriod"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6></v-flex>

                      <!-- <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="allSelectedList" v-model="form.fund" :label="label.fund" item-text="label" item-value="value"
                          data-vv-name="fund" :data-vv-as="label.fund" :error-messages="errors.collect('fund')" @change="doFund"></v-autocomplete>
                      </v-flex> -->
                      <!-- <v-flex lg6 sm6 xs12 v-if="form.fund == 'Selected'">
                        <v-autocomplete :items="fundList" v-model="form.sFund" :label="label.sFund" item-text="label" item-value="value" multiple
                          data-vv-name="sFund" :data-vv-as="label.sFund" :error-messages="errors.collect('sFund')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6 v-else></v-flex> -->
                        <v-flex lg6 sm6 xs12>
                          <v-text-field v-model="form.fund" :label="label.fund" :error-messages="errors.collect('fund')"
                            data-vv-name="fund" :data-vv-as="label.fund" append-icon="mdi-magnify"
                            @click:append="getHelpList()" v-validate="'required'" readonly></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
        <v-dialog v-model="helplist" width="900px" persistent>
          <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
        </v-dialog>
      </v-card>
      <v-flex lg6 sm6 xs12>
        <v-checkbox color="primary" :label="label.printRptRunTime" v-model="form.printRptRunTime"></v-checkbox>
      </v-flex>
      <v-flex xs12>
        <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
          {{ label.export }}
        </v-btn>
        <v-btn-toggle dense mandatory v-model="form.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{ format.label }}</span>
            <v-icon :color="format.color">{{ format.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </div>

  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import clone from 'clone'
import { allSelectedList, rptTypes } from './index'
import Helplist from '../Helplist'

export default {
  data() {
    return {
      label: {
        rptType: 'Report Type',
        createdDate: 'Created Date',
        acctPeriod: 'Accounting Period',
        fund: 'Fund',
        sFund: 'Selected Fund(s)',
        printRptRunTime: 'Print Runtime Parameters',
        export: 'Export To',
        format: 'Export Format'
      },
      form: {
        rptType: 'D',
        createdDate: new Date(),
        acctPeriod: '',
        fund: 'All',
        sFund: '',
        printRptRunTime: true,
        runRpt: '',
        format: undefined
      },
      fundList: [],
      acctPeriodList: [],
      supportedFormat: [],
      loading: false,
      submitting: false,
      menu: {},
      toggleFilters: [true],
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      disableAcctPeriod: true,
      disableCreatedDate: false,
      allSelectedList: [],
      rptTypes: [],
      // HelpList
      helplist: false,
      mode: 'fund',
      apiURI: '',
      param: '',
      panel: [0]
    }
  },
  methods: {
    async doInit() {
      this.form.runRpt = this.runRpt
      await this.$store.dispatch('accountReportsInit')
      const apiURI = this.rptMenu.bankAccounts
      const result = await this.$http.get(apiURI)
      if (result.data) {
        const { data } = result.data
        if (data) {
          this.supportedFormat = data.format
          this.menu = extractMenu(result.data._links)
        }
      }
      this.getFundList()
      this.getAcctPeriod()
    },
    async getFundList() {
      const apiURI = this.menu.fundList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.fundList = []
          if (data) {
            for (let i in data) {
              this.fundList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getAcctPeriod() {
      const apiURI = this.menu.acctPeriodList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.acctPeriodList = []
          if (data) {
            for (let i in data) {
              this.acctPeriodList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doFund() {
      if (this.form.fund === 'All') {
        this.form.sFund = ''
      }
    },
    getHelpList(fieldName) {
      this.apiURI = this.menu.fundList
      this.param = this.form.fund
      this.helplist = true
    },
    doClose() {
      this.helplist = false
    },
    doAssign(Obj) {
      this.form.fund = ''
      this.form.fund = Obj.finalSelectedItems.toString()
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportBankAcct
      if (apiURI) {
        try {
          this.submitting = true
          let massageForm = clone(this.form)
          if (massageForm.sFund) {
            massageForm.sFund = this.form.sFund.join()
          }
          await this.$http.post(apiURI, massageForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doRptType(obj) {
      this.resetMessages()
      this.form.rptType = obj
      if (this.form.rptType === 'D') {
        this.disableAcctPeriod = true
        this.disableCreatedDate = false
        this.form.acctPeriod = ''
      } else if (this.form.rptType === 'M') {
        this.disableAcctPeriod = false
        this.disableCreatedDate = true
        this.form.createdDate = ''
      }
    }
  },
  created() {
    this.doInit()
    this.allSelectedList = allSelectedList
    this.rptTypes = rptTypes
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    runRpt: {
      type: String,
      default: '2'
    }
  },
  components: {
    Helplist
  }
}

</script>
